import { Link } from "react-router-dom";
import { ArrowRight, Globe2, HeartHandshake, ShieldCheck } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1672309558498-cfcc89afff25?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const Section = ({ eyebrow, title, text, children }) => (
  <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24">
    <p className="eyebrow rise">{eyebrow}</p>
    <h1 className="rise d1 mt-3 max-w-3xl text-4xl font-extrabold text-white sm:text-5xl lg:text-6xl">{title}</h1>
    {text && <p className="rise d2 mt-6 max-w-2xl text-base leading-relaxed text-slate-300">{text}</p>}
    {children}
  </div>
);

const VALUES = [
  { icon: ShieldCheck, title: "Trust first", text: "Every payment is verified with our payment partner before anything is delivered." },
  { icon: Globe2, title: "Built for Ghana", text: "Local pricing in Ghana Cedis and familiar payment methods like Mobile Money." },
  { icon: HeartHandshake, title: "Real support", text: "A responsive team ready to help with orders, access and payments." },
];

export default function About() {
  return (
    <Section eyebrow="About Raphanex" title="An online store for quality digital products."
      text="Raphanex Store is a Ghanaian digital-commerce platform where customers discover and purchase digital products — e-books, design templates, software tools, online courses, and other downloadable resources — with secure local payments and instant delivery.">
      <div className="mt-16 grid items-center gap-12 lg:grid-cols-2">
        <img src={IMG} alt="Raphanex workspace" className="aspect-[4/3] w-full rounded-3xl border border-white/10 object-cover" />
        <div className="space-y-5 text-slate-300">
          <h2 className="text-2xl font-bold text-white">Our mission</h2>
          <p className="leading-relaxed">We make buying digital products simple, safe and immediate. No shipping, no waiting — once your payment is confirmed, your product lives in your account forever.</p>
          <p className="leading-relaxed">Registered members can also access additional specialised services from their dashboard, offered separately from the main store.</p>
          <Link to="/products" className="btn-primary" data-testid="about-browse-btn">Explore the store <ArrowRight size={16} /></Link>
        </div>
      </div>
      <div className="mt-20 grid gap-5 md:grid-cols-3">
        {VALUES.map((v) => (
          <div key={v.title} className="card-rx p-8">
            <v.icon size={24} className="text-amber-400" />
            <h3 className="mt-5 text-lg font-semibold text-white">{v.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{v.text}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}
